import React from "react";
import { useApi } from "../../../hooks/useApi";
import { API_ENDPOINTS } from "../../../api/endpoints";
import { useNavigate } from "react-router-dom";
import styles from "../Membership.module.css";
import Loader from "../../../components/Loader/Loader";
import ErrorMsg from "../../../components/ErrorMsg/ErrorMsg";

export default function Institutional() {
  const { response, loading, error } = useApi(
    API_ENDPOINTS.HOME_INSITUTIONAL_PARTNERS
  );
  const apiData = response?.institutionalPartners;
  const navigate = useNavigate();
  return (
    <section className={styles.institutional}>
      <div className={styles.container}>
        <div className={styles.topContainer}>
          <div className={styles.heading}>
            <h3>
              Knowledge  <span>Partners</span>
            </h3>
            <h5>Partner institutions driving research excellence</h5>
          </div>
         <div className={styles.viewAll}>
            <button onClick={() => navigate("/institutions")}>View All </button>
          </div>
        </div>

        <div className={styles.cardRow}>
          {loading ? (
            <Loader />
          ) : error ? (
            <ErrorMsg />
          ) : (
            apiData.slice(0, 2).map((item) => (
               <article className={styles.card} key={item.id}>
                <figure>
                  <img src={item.institution_profile.logo} alt={item.title} />
                </figure>
                <div className={styles.content}>
                  <h4 title={item.institution_profile.institution}>{item.institution_profile.institution}</h4>
                  <p>
                    {item.institution_profile.city}, { item.institution_profile?.state?.name}, {item.institution_profile?.country?.name}
                  </p>
                  <p><strong> Member Since:</strong> {item.institution_profile.estYear}</p>
                   
                  {/* <button
                    onClick={() =>
                      window.open(
                        item.institution_profile.brochure,
                        "_blank",
                        "noopener,noreferrer"
                      )
                    }
                  >
                    View MoU
                  </button> */}
                  <button
                    onClick={() => navigate(`/institutions/${item.institution_profile.user_id}`)}
                  >
                    View Profile
                  </button>


                </div>
              </article>
            ))
          )}
        </div>
      </div>
    </section>
  );
}
